import { Button, Checkbox, MenuItem, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { PaymentTypesContext } from './PaymentTypesContext';
import { useTranslate } from 'react-admin';
import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact';
import { FormProvider, useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const timeConfigDefault = [
    {
        "day": 0,
        "name": "lun",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 1,
        "name": "mar",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 2,
        "name": "mie",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 3,
        "name": "jue",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 4,
        "name": "vie",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 5,
        "name": "sab",
        "from": "00:00:00",
        "to": "00:00:00"
    },
    {
        "day": 6,
        "name": "dom",
        "from": "00:00:00",
        "to": "00:00:00"
    }
]

const HourInput = ({day, handleChangeForm, form, field}) =>{
  const currentDay = form.time_config.find(time=>time.day === day.day)
  const displayTime = (date) =>{
    if(!date){
      return ''
    }
    const timeFormatted = date.split(':')
    return timeFormatted[0] + ':' + timeFormatted[1]
  }
  const [value, setValue] = useState(displayTime(currentDay[field]))

  useEffect(()=>{
    const currentDay = form.time_config.find(time=>time.day === day.day)
    if(currentDay.from === '00:00:00' && currentDay.to === '23:59:59')
      setValue(displayTime(currentDay[field]))
  },[form.time_config])

  const formatCustomInput = (newValue) =>{
    let formattedValue = ''
    newValue = newValue.includes(':') ? newValue.replace(':','') :newValue
    if(
      (
        newValue[0] && newValue[1] && 
          (
            Number.isNaN(Number(newValue[0] + newValue[1])) ||
            Number(newValue[0] + newValue[1]) > 23
          ) 
      )
    ){
      newValue = '00' + newValue[2] + newValue[3]
    }
    if(
      newValue[2] && newValue[3] && 
        (
          Number.isNaN(Number(newValue[2] + newValue[3])) ||
          Number(newValue[2] + newValue[3]) > 59
    )){
      newValue = newValue[0] + newValue[1] + '00'
    }
    for(let i = 0; i < 4; i++){
      if(i === 2){
        formattedValue += ':'
      }
      if(newValue[i]){
        formattedValue += newValue[i]
      } else {
        formattedValue += 0
      }
    }

    setValue(formattedValue)
  }

  useEffect(()=>{
    const currentDay = form.time_config.find(time=>time.day === day.day)
    if(currentDay.from !== '00:00:00' || currentDay.to !== '23:59:59'){
      handleChangeForm('time_config',form.time_config.map(date=>{
        return(
          date.day === day.day ?
          {...date, [field]:value.length > 5 ? value : value + ':00'} :
          date)
        })
      )
    }
  },[value])
  
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TimePicker
        disabled = {day.from === '00:00:00' && day.to === '23:59:59'}
        onChange={(newValue) => {
          const valueDate = new Date(newValue)
          const valueTime = valueDate.toTimeString().split(' ')[0].split(':')
          
          setValue(displayTime(valueTime[0] + ':' + valueTime[1] + ':00'))
          }}
        renderInput={(params) => <TextField 
          {...params}
          key={day.day}
          onChange={(e)=>setValue(e.target.value)}
          onBlur={()=>formatCustomInput(value)}
          style={{width:'12.5%'}}
          size='small'
          inputProps={{ maxLength: 8 }}
          value={value}
        />}
      />
    </LocalizationProvider>
  )
}

export const PaymentPerProductDialog = ({setOpenDialog, setPaymentsPerProduct, setPaymentsEdited, paymentPerProduct = null}) => {
  const translate = useTranslate()
  const { availablePaymentTypes, currencies, idCount, setIdCount } = useContext(PaymentTypesContext);
  const [paymentTypeError, setPaymentTypeError] = useState(false)
  const [selectAll, setSelectAll] = useState(false)
  const [form, setForm] = useState({
    payment_type_id:paymentPerProduct?.payment_type_id ?? '',
    currency_id:paymentPerProduct?.currency_id ?? null,
    time_config:paymentPerProduct?.time_config ?? timeConfigDefault,
    config:paymentPerProduct?.config ?? {}
  })

  const handleChangeForm = (field, value) =>{
    setForm({...form, [field]:value})
  }

  const onSelectedAll = () =>{
    setSelectAll(selected=>!selected)
    if(!selectAll){
      handleChangeForm('time_config',form.time_config.map(date=>{
        return(
          {...date, from:'00:00:00', to:'23:59:59'})
        })
      )
    } else {
      handleChangeForm('time_config',form.time_config.map(date=>{
        return(
          {...date, from:'00:00:00', to:'23:59:00'})
        })
      )
    }
  }

  const formatTime = (value) => {
    // Remove all non-digit characters
    const digits = value.replace(/\D/g, '').slice(0, 6);
    const parts = [digits.slice(0, 2), digits.slice(2, 4), digits.slice(4, 6)];
    return parts.map((p) => p.padEnd(2, '0')).join(':');
  };

  const jsonForm = useForm({
    defaultValues: {
      config:paymentPerProduct?.config ?? {}
    },
  });

  /* const removePaymentTypeOptions = (idToRemove) =>{
    setAvailablePaymentTypes(availablePaymentTypes.filter(pay=>pay.id !== idToRemove))
  } */

  const onSubmit = () =>{
    if(form.payment_type_id){
      if(paymentPerProduct){
        setPaymentsPerProduct(payments=>
          payments.map(payment=>
            (paymentPerProduct.auxId && payment.auxId === paymentPerProduct.auxId) ? {...payment, ...form} :
            (paymentPerProduct.id && payment.id === paymentPerProduct.id) ? {...payment, ...form} :
            payment)
        )
        if(paymentPerProduct.auxId){
          setPaymentsEdited(payments=>
          payments.map(payment=>
            (paymentPerProduct.auxId && payment.auxId === paymentPerProduct.auxId) ? {...payment, ...form} :
            payment))
        }
        else if(paymentPerProduct.id){
          setPaymentsEdited(payments=>[...payments, {...form, id:paymentPerProduct.id}])
        }
      } else{
        form.auxId = idCount
        setIdCount(idCount + 1)
        setPaymentsPerProduct(payments=>[...payments, form])
        setPaymentsEdited(payments=>[...payments, form])
      }
      /* removePaymentTypeOptions(form.payment_type_id) */
      setOpenDialog(false)
    } else {
      setPaymentTypeError(true)
    }
  }

  const onCancel = () =>{
    setOpenDialog(false)
    /* if(paymentPerProduct)
      removePaymentTypeOptions(paymentPerProduct.payment_type_id) */
  }

  return (
    <div>
        <TextField
          select
          id='paymentTypes'
          label={translate('ra.entity.payment-method')}
          size="small"
          style={{marginTop:'15px'}}
          fullWidth
          required
          error = {paymentTypeError}
          variant="outlined"
          value={form.payment_type_id}
          onChange={(e) =>{handleChangeForm('payment_type_id',e.target.value);setPaymentTypeError(false)}}
        >
          {availablePaymentTypes.map((item) => (
          <MenuItem key={item.id} value={item.id}>
              {item.long_name}
          </MenuItem>
          ))}
      </TextField>

      <TextField
          select
          id='currency'
          size="small"
          fullWidth
          style={{marginTop:'15px'}}
          label={translate('ra.field.currency')}
          variant="outlined"
          value={form.currency_id}
          onChange={(e) =>{handleChangeForm('currency_id',e.target.value)}}
        >
          {currencies.map((item) => (
          <MenuItem key={item.id} value={item.id}>
              {item.long_name}
          </MenuItem>
          ))}
      </TextField>
      <div style={{marginTop:'15px'}}>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly'}}>
            <div style={{width:'12.5%'}}>
              <div style={{display:'flex', flexDirection:'row', alignItems:'center', fontSize:'12px'}}>
                {'Todos'}
                <Checkbox 
                  checked={selectAll}
                  onChange={onSelectedAll}
                />
              </div>
            </div>
            {form.time_config.map(day=>(
                <div key={day.day} style={{alignSelf:'center', alignItems:'center',width:'12.5%', display:'flex', flexDirection:'row', justifyContent:'space-evenly'}}>
                  {day.name}
                  <div style={{display:'flex', flexDirection:'row', alignItems:'center', fontSize:'12px'}}>
                    {'24hs'}
                    <Checkbox 
                      checked={(day.from === '00:00:00' && day.to === '23:59:59')} 
                      size='small'
                      onChange={val=>{
                        if(val.target.checked){
                          handleChangeForm('time_config',form.time_config.map(date=>{
                            return(
                              date.day === day.day ?
                              {...date, from:'00:00:00', to:'23:59:59'} :
                              date)
                            })
                          )
                        } else {
                          handleChangeForm('time_config',form.time_config.map(date=>{
                            return(
                              date.day === day.day ?
                              {...date, from:'00:00:00', to:'23:59:00'} :
                              date)
                            })
                          )
                        }
                      }}
                    />
                  </div>
                </div>
            ))}
          </div>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly', alignItems:'center'}}>
            <div style={{width:'12.5%'}}>
              {translate('ra.field.from')}
            </div>
            {form.time_config.map(day=>(
              <HourInput day={day} form={form} handleChangeForm={handleChangeForm} field={'from'}/>
            ))}
          </div>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-evenly', alignItems:'center'}}>
            <div style={{width:'12.5%'}}>
              {translate('ra.field.to')}
            </div>
            {form.time_config.map(day=>(
              <HourInput day={day} form={form} handleChangeForm={handleChangeForm} field={'to'}/>
              
            ))}
          </div>
      </div>
      <div style={{marginTop:'15px'}}>
        <label htmlFor="">{'Config'}</label>
        <FormProvider {...jsonForm}>
          <JsonInput source='config' width='auto' onChange={(edit) => {handleChangeForm('config', edit)}}/>
        </FormProvider>
      </div>
      <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', width:'100%', marginTop:'15px'}}>
            <LoadingButton
              variant='contained'
              onClick={onSubmit}
            >
              {paymentPerProduct ? translate('ra.action.edit') : translate('ra.action.add')}
            </LoadingButton>
            <Button
              color='error'
              variant='outlined'
              onClick={onCancel}
            >
              {translate('ra.action.cancel')}
            </Button>
      </div>
    </div>
  )
}